<div class="flex flex-col h-full w-full overflow-hidden">
  <!-- Header -->
  <div class="flex justify-between items-center p-4 h-auto">
    <!-- Logo -->
    <div class="w-30 h-auto">
        <img class="w-90 h-auto" src="images/logo/logo.svg" />
    </div>

    <button mat-icon-button mat-dialog-close (click)="close()" class="icon-size-2" *ngIf="shouldShowCloseButton()">
            <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Main Content - Enhanced for better space distribution -->
  <div class="flex-grow flex flex-col h-full px-4 sm:px-6">
    <!-- Top section with title and text -->
    <div class="flex flex-col items-center justify-center w-full pt-6 sm:pt-10 mb-4 sm:mb-8">
      <h1 class="text-3xl sm:text-3xl font-extrabold leading-tight text-center">
        {{ 'otpvalidation.otpchangepwdtitle' | transloco }}
      </h1>
      
    </div>
    
    <!-- Middle Section - Flexible space -->
    <div class="flex-grow flex flex-col justify-center items-center ">
      <form [formGroup]="registrationForm" class="w-full max-w-lg mx-auto">
      <div class="relative mb-5 floating-label password-field">
        <input 
          type="password"
          required
          formControlName="password"
          id="regpassword" 
          #regpassword
          class="placeholder-base text-base w-full border border-gray-300 rounded-lg px-4 py-4 pr-12 focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
          [ngClass]="{'border-red-500': registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched}"
        />
        <label for="regpassword" class="floating-label">{{ 'login.otpNewPwd' | transloco }}</label>
        
        <button
          type="button"
          class="absolute right-3 top-4"
          (click)="regpassword.type === 'password' ? (regpassword.type = 'text') : (regpassword.type = 'password')"
        >
          @if (regpassword.type === 'password') {
            <mat-icon class="text-gray-500">visibility</mat-icon>
          }
          @if (regpassword.type === 'text') {
            <mat-icon class="text-gray-500">visibility_off</mat-icon>
          }
        </button>
        <div *ngIf="!registrationForm.get('password')?.invalid || !registrationForm.get('password')?.touched" 
             class="text-base text-gray-500 mt-1 ml-1">
          {{ 'validations.passwordRecommendation' | transloco }}
        </div>
        <!-- Error messages -->
        <div *ngIf="registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched" class="text-base text-red-500 mt-1 ml-1 flex items-center">
          <div *ngIf="registrationForm.get('password')?.errors?.['required']" >
            <mat-icon class="mr-2 text-red-500 icon-size-5">error_outline</mat-icon>
            <span>{{ 'validations.passwordRequired' | transloco }}</span>
          </div>
          <div *ngIf="registrationForm.get('password')?.errors?.['minlength'] || registrationForm.get('password')?.errors?.['maxlength']" class="text-base flex items-center">
            <mat-icon class="mr-2 text-red-500 icon-size-5">error_outline</mat-icon>
            <span>{{ 'validations.passwordLength' | transloco }}</span>
          </div>
        </div>
      </div>
    </form>
    </div>

    <!-- Bottom section with button and text -->
    <div class="w-full max-w-lg mx-auto pb-6 sm:pb-8">
      <button 
        (click)="cambiarContrasenya()"
        class="w-full my-button py-4 mt-0 text-white rounded-full font-semibold text-base md:text-base transition shadow btnactions-base bg-teal-700 hover:bg-teal-800"
        [disabled]="isLoading"
      >
        <div class="flex items-center justify-center">
          <div *ngIf="isLoading" class="mr-2">
            <mat-spinner [diameter]="20" style="--mdc-circular-progress-active-indicator-color: white;"></mat-spinner>
          </div>
          <span>{{ isLoading ? ('register.checking' | transloco) : ('otpvalidation.changepwdBtn' | transloco) }}</span>
        </div>
      </button>
      <p class="text-base text-gray-500 mt-4 text-center">
        <button (click)="close()" class="text-[#006E75] hover:text-[#003E42] hover:underline underline underline-offset-2 font-medium">
            {{'otpvalidation.postpone' | transloco}}
        </button>
      </p>
    </div>
  </div>
</div>